import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import SplashPage from "@/pages/SplashPage";
import DeckPage from "@/pages/DeckPage";
import ExplorePage from "@/pages/ExplorePage";
import ProjectPage from "@/pages/ProjectPage";
import TagPage from "@/pages/TagPage";
import SavedPage from "@/pages/SavedPage";
import SupportedPage from "@/pages/SupportedPage";
import SignInPage from "@/pages/SignInPage";
import VerifyPage from "@/pages/VerifyPage";
import AdminPage from "@/pages/AdminPage";
import BuilderPage from "@/pages/BuilderPage";
import ProfilePage from "@/pages/ProfilePage";
import WinnersPage from "@/pages/WinnersPage";
import { AboutPage, PrivacyPage, TermsPage, NotFound } from "@/pages/StaticPages";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SplashPage />} />
          <Route path="/deck" element={<DeckPage />} />
          <Route path="/explore" element={<ExplorePage />} />
          <Route path="/p/:slug" element={<ProjectPage />} />
          <Route path="/tags/:tag" element={<TagPage />} />
          <Route path="/saved" element={<SavedPage />} />
          <Route path="/supported" element={<SupportedPage />} />
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/auth/verify" element={<VerifyPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/builder" element={<BuilderPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/winners" element={<WinnersPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" toastOptions={{ style: { background: "#12305A", color: "#fff", border: "1px solid rgba(255,255,255,0.1)" } }} />
    </AppProvider>
  );
}

export default App;
